
import {
  BECOME_A_PARTNER,
  GLOBAL_IMPORTS,
  HOME,
  IMPORT_FROM_CHINA,
} from '../routes/routeConstants';

export interface DropDownDataInterface {
  label: string;
  link: string;
  description: string;
  icon?: React.ReactNode;
}

export interface INavConfig {
  title: string;
  path?: string;
  dropDownItems?: DropDownDataInterface[];
}

export const navConfig: INavConfig[] = [
 {
  title: 'Home',
  path: HOME,
 },
 {
  title: 'Become a Partner',
  path: BECOME_A_PARTNER,
 },
 {
  title: 'Import from Anywhere',
  dropDownItems: [
   {
    link: GLOBAL_IMPORTS,
    label: 'Global Brands',
    description: 'Source products from global brands worldwide.',
   },
   {
    link: IMPORT_FROM_CHINA,
    label: 'Chinese Brands',
    description: 'Access a wide range of top Chinese stores.',
   },
  ],
 },
 // {
 //   title: 'Services',
 //   dropDownItems: [
 //     {
 //       link: ENTERPRISE_LOGISTICS,
 //       label: 'Enterprise Logistics',
 //       description: 'Streamline supply chain, cut costs, boost satisfaction.',
 //       icon: <BagNavIcon />,
 //     },
 //     {
 //       link: SUPPLY_CHAIN_STORAGE,
 //       label: 'Supply-chain Storage',
 //       description: 'Advanced warehouses and expert team to ensure safe.',
 //       icon: <SupplyNavIcon />,
 //     },
 //     {
 //       link: CUSTOM_CLEARANCE,
 //       label: 'Custom Clearance',
 //       description: 'Optimized processing for quick customs clearance.',
 //       icon: <CustomNavIcon />,
 //     },
 //     {
 //       link: LAST_MILE_DELIVERY,
 //       label: 'Last-mile Delivery',
 //       description: 'Seamless transportation from parcel to destination.',
 //       icon: <LastMileNavIcon />,
 //     },
 //   ],
 // },
 // {
 //   title: 'Contact Us',
 //   path: CONTACT,
 // },
];
